import React, { useEffect, useState } from "react";
import styles from "../../Application.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import EquipmentImage from "../../../../../../images/v2/equipnent_placeholder.png";
import config from "../../../../../config";
import useCommonStore from "../../../../stores/common";
const STRATUS_URL = config.paymentcloud.STRATUS_URL;

const TerminalTypes = [
  {
    value: "pax-a920",
    label: "Pax A920",
  },
  {
    value: "pax-a80",
    label: "Pax A80",
  },
  {
    value: "dejavoo-z9",
    label: "Dejavoo z9",
  },
  {
    value: "dejavoo-qd4",
    label: "Dejavoo QD4",
  },
  {
    value: "dejavoo-qd2",
    label: "Dejavoo QD2",
  },
  {
    value: "dejavoo-z8",
    label: "Dejavoo z8",
  },
  {
    value: "bbpos",
    label: "BBPOS 3-in-1 Bluetooth Card Reader",
  },
  {
    value: "payanywhere-smart-terminal-mini",
    label: "Payanywhere Smart Terminal Mini",
  },
  {
    value: "payanywhere-smart-flex",
    label: "Payanywhere Smart Flex",
  },
  {
    value: "payanywhere-smart-pos",
    label: "Payanywhere Smart POS+",
  },
  {
    value: "payanywhere-smart-terminal",
    label: "PayAnywhere Smart Terminal",
  },
  {
    value: "payanywhere-smart-keypad",
    label: "PayAnywhere Smart Keypad",
  },
  {
    value: "payanywhere-mobile-card-reader",
    label: "PayAnywhere 3-in-1 Mobile Card Reader",
  },
  {
    value: "VAR",
    label: "VAR",
  },
  {
    value: "VL100",
    label: "VL100 (Standard Terminal)",
  },
  {
    value: "VL110",
    label: "VL110 (Wireless Terminal)",
  },
  {
    value: "VL500",
    label: "VL500 (Pro Terminal)",
  },
  {
    value: "VL300",
    label: "VL300 (Pin Pad)",
  },
];

const GatewayTypes = [
  {
    value: "authorize_net",
    label: "Authorize.net",
  },
  {
    value: "authorizenet",
    label: "Authorize.net",
  },
  {
    value: "nmi-gateway",
    label: "NMI",
  },
  {
    value: "nmi",
    label: "NMI",
  },
  {
    value: "usa_e_pay",
    label: "USAePay",
  },
  {
    value: "usaepay-gateway",
    label: "USAePay",
  },
  {
    value: "paysley",
    label: "Paysley",
  },
  {
    value: "paysley-gateway",
    label: "Paysley",
  },
  {
    value: "VAR",
    label: "VAR",
  },
];

function Equipment({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expended, setExpended] = useState(false);
  const [purchasedEquipments, setPurchasedEquipments] = useState([]);
  const [purchaseTotal, setPurchaseTotal] = useState(0);
  // monthly, rent, lease
  const [rentedEquipments, setRentedEquipments] = useState([]);
  const [monthlyEquipments, setMonthlyEquipments] = useState([]);
  const [leasedEquipments, setLeasedEquipments] = useState([]);
  const [monthlyTotal, setMonthlyTotal] = useState(0);

  const [tppEquipments, setTppEquipments] = useState([]);

  const toggleExpend = () => {
    setExpended(!expended);
  };

  useEffect(() => {
    let equipments = appData?.ems_boot_equipments;
    if (equipments) {
      let purchases = equipments.filter(
        (equipment) => equipment.purchase_for !== null,
      );
      setPurchasedEquipments(purchases);
      let purchase_total = purchases.reduce((acc, current) => {
        acc += current.purchase_for;
        return acc;
      }, 0);
      setPurchaseTotal(purchase_total);

      let rent = equipments.filter((equipment) => equipment.rent_for !== null);
      setRentedEquipments(rent);
      let rent_total = rent.reduce((acc, current) => {
        acc += current.rent_for;
        return acc;
      }, 0);

      let monthly = equipments.filter(
        (equipment) => equipment.monthly_fee !== null,
      );
      setMonthlyEquipments(monthly);
      let monthly_total = monthly.reduce((acc, current) => {
        acc += current.monthly_fee;
        return acc;
      }, 0);

      let lease = equipments.filter(
        (equipment) => equipment.lease_for !== null,
      );
      setLeasedEquipments(lease);

      let lease_total = lease.reduce((acc, current) => {
        acc += current.lease_for;
        return acc;
      }, 0);

      setMonthlyTotal(rent_total + monthly_total + lease_total);

      let tpp = equipments.filter((equipment) => equipment.tpp == "yes");
      setTppEquipments(tpp);
    }
  }, [JSON.stringify(appData)]);

  const getTerminal = (key) => {
    let terminal_name = null;
    TerminalTypes.forEach((item, index) => {
      if (item.value == key) {
        terminal_name = TerminalTypes[index].label;
      }
    });
    return terminal_name;
  };

  const getGateway = (key) => {
    let gateway_name = null;
    GatewayTypes.forEach((item, index) => {
      if (item.value == key) {
        gateway_name = GatewayTypes[index].label;
      }
    });
    return gateway_name;
  };

  return (
    <div
      className={`${styles.equipment} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={styles.head}>
        <ButtonIcon onClick={toggleExpend}>
          <svg
            className={expended ? styles.expended : ""}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.0306 12.5307L9.53062 20.0307C9.46093 20.1004 9.37821 20.1556 9.28716 20.1933C9.19612 20.2311 9.09854 20.2505 8.99999 20.2505C8.90144 20.2505 8.80386 20.2311 8.71282 20.1933C8.62177 20.1556 8.53905 20.1004 8.46936 20.0307C8.39968 19.961 8.34441 19.8783 8.30669 19.7872C8.26898 19.6962 8.24957 19.5986 8.24957 19.5001C8.24957 19.4015 8.26898 19.3039 8.30669 19.2129C8.34441 19.1218 8.39968 19.0391 8.46936 18.9694L15.4397 12.0001L8.46936 5.03068C8.32863 4.88995 8.24957 4.69907 8.24957 4.50005C8.24957 4.30103 8.32863 4.11016 8.46936 3.96943C8.61009 3.8287 8.80097 3.74963 8.99999 3.74963C9.19901 3.74963 9.38988 3.8287 9.53062 3.96943L17.0306 11.4694C17.1003 11.5391 17.1557 11.6218 17.1934 11.7128C17.2312 11.8039 17.2506 11.9015 17.2506 12.0001C17.2506 12.0986 17.2312 12.1962 17.1934 12.2873C17.1557 12.3783 17.1003 12.461 17.0306 12.5307Z"
              fill="#3A383F"
            />
          </svg>
        </ButtonIcon>
        <h5>Equipment</h5>
      </div>

      <div className={`${styles.body} ${expended ? styles.body_expended : ""}`}>
        {expended && (
          <>
            {!appData?.billing ? (
              <>
                <div>
                  <ul>
                    <li>
                      <div>
                        <p>Equipment Type</p>
                        <p>
                          {appData?.powerappequipment?.equipment_option ==
                            "terminal"
                            ? "Terminal"
                            : "Gateway"}
                        </p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <p>Equipment paid for by</p>
                        <p>
                          {appData?.powerappequipment?.gateway_option ===
                            "paymentcloud_provided"
                            ? "Merchant"
                            : "Agent"}
                        </p>
                      </div>
                    </li>

                    {appData?.powerappequipment?.equipment_option ===
                      "terminal" && (
                        <li>
                          <div>
                            <p>Terminal Type</p>
                            <p>
                              {appData?.powerappequipment?.equipment_type?.trim()
                                ? appData.powerappequipment.equipment_type
                                : getTerminal(
                                  appData?.powerappequipment?.terminal_name,
                                )}
                            </p>
                          </div>
                        </li>
                      )}

                    {appData?.powerappequipment?.equipment_option ===
                      "gateway" && (
                        <li>
                          <div>
                            <p>Gateway Type</p>
                            <p>
                              {appData?.powerappequipment?.equipment_type?.trim()
                                ? appData.powerappequipment.equipment_type
                                : getGateway(
                                  appData?.powerappequipment?.gateway_name,
                                )}
                            </p>
                          </div>
                        </li>
                      )}

                    {appData?.powerappequipment?.special_instruction && (
                      <li>
                        <div>
                          <p>Special Instruction</p>
                          <p>
                            {appData?.powerappequipment?.special_instruction}
                          </p>
                        </div>
                      </li>
                    )}

                    {appData?.powerappequipment?.equipment_option ===
                      "terminal" && (
                        <li>
                          <div>
                            <p>Shipping Address</p>
                            <p>
                              {appData?.powerappequipment?.merchant_dba_address}
                            </p>
                          </div>
                        </li>
                      )}

                    {appData?.powerappequipment?.gateway_id && (
                      <li>
                        <div>
                          <p>Gateway Id</p>
                          <p>{appData?.powerappequipment?.gateway_id}</p>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </>
            ) : (
              <>
                {/* Purchase */}
                {purchasedEquipments.length > 0 && (
                  <div>
                    <HeadingWithLine text="Purchases" line={false} />
                    <div className={styles.equipment_list}>
                      {purchasedEquipments.map((equipment, index) => {
                        let equipment_data = equipment?.terminal
                          ? equipment?.terminal
                          : equipment?.gateway;
                        return (
                          <div key={index} className={styles.equipment_list_item}>
                            <div>
                              <div className={styles.left}>
                                <img
                                  src={`${STRATUS_URL}get-image-by-path?path=${equipment_data?.equipment_image}`}
                                />
                                <div className={styles.equipment_nq}>
                                  <span>{equipment_data?.equipment_name}</span>
                                  <span>X {equipment?.quantity} </span>
                                </div>
                              </div>
                              <div className={styles.right}>
                                $ {equipment?.purchase_for}.00
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <div className={styles.total}>
                        <span>Total</span>
                        <span>$ {purchaseTotal}.00</span>
                      </div>
                    </div>
                  </div>
                )}
                {/* end Purchase */}

                {/* Monthly */}
                {(rentedEquipments.length > 0 || leasedEquipments.length > 0 || monthlyEquipments.length > 0) && (
                  <div>
                    <HeadingWithLine text="Monthly cost" line={false} />
                    <div className={styles.equipment_list}>
                      {rentedEquipments.map((equipment, index) => {
                        let equipment_data = equipment?.terminal
                          ? equipment?.terminal
                          : equipment?.gateway;
                        return (
                          <div key={index} className={styles.equipment_list_item}>
                            <div>
                              <div className={styles.left}>
                                <img
                                  src={`${STRATUS_URL}get-image-by-path?path=${equipment_data?.equipment_image}`}
                                />
                                <div className={styles.equipment_nq}>
                                  <span>{equipment_data?.equipment_name} <span className={styles.badge} >Rent</span> </span>
                                  <span>X {equipment?.quantity} </span>
                                </div>
                              </div>
                              <div className={styles.right}>
                                $ {equipment?.rent_for}.00
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {leasedEquipments.map((equipment, index) => {
                        let equipment_data = equipment?.terminal
                          ? equipment?.terminal
                          : equipment?.gateway;
                        return (
                          <div key={index} className={styles.equipment_list_item}>
                            <div>
                              <div className={styles.left}>
                                <img
                                  src={`${STRATUS_URL}get-image-by-path?path=${equipment_data?.equipment_image}`}
                                />
                                <div className={styles.equipment_nq}>
                                  <span>{equipment_data?.equipment_name} <span className={styles.badge} >Lease</span> </span>
                                  <span>X {equipment?.quantity} </span>
                                </div>
                              </div>
                              <div className={styles.right}>
                                $ {equipment?.lease_for}.00
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {monthlyEquipments.map((equipment, index) => {
                        let equipment_data = equipment?.terminal
                          ? equipment?.terminal
                          : equipment?.gateway;
                        return (
                          <div key={index} className={styles.equipment_list_item}>
                            <div>
                              <div className={styles.left}>
                                <img
                                  src={`${STRATUS_URL}get-image-by-path?path=${equipment_data?.equipment_image}`}
                                />
                                <div className={styles.equipment_nq}>
                                  <span>{equipment_data?.equipment_name} <span className={styles.badge} >Monthly</span> </span>
                                  <span>X {equipment?.quantity} </span>
                                </div>
                              </div>
                              <div className={styles.right}>
                                $ {equipment?.monthly_fee}.00
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <div className={styles.total}>
                        <span>Total</span>
                        <span>$ {monthlyTotal}.00</span>
                      </div>
                    </div>
                  </div>
                )}
                {/* end Monthly */}

                {/* TPP */}
                {tppEquipments.length > 0 && (
                  <div>
                    <HeadingWithLine text="TPP Hardware" line={false} />
                    <div className={styles.equipment_list}>
                      {/* Items */}
                      {tppEquipments.map((equipment, index) => {
                        let equipment_data = equipment?.terminal
                          ? equipment?.terminal
                          : equipment?.gateway;
                        return (
                          <div key={index} className={styles.equipment_list_item}>
                            <div>
                              <div className={styles.left}>
                                <img
                                  src={`${STRATUS_URL}get-image-by-path?path=${equipment_data?.equipment_image}`}
                                />
                                <div className={styles.equipment_nq}>
                                  <span>{equipment_data?.equipment_name}</span>
                                  <span>X 1 </span>
                                </div>
                              </div>
                              <div className={`${styles.tpp_price}`}>
                                <span>$ 450.00</span>
                                <span>$ 0.00</span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* end Items */}
                    </div>
                  </div>
                )}
                {/* end TPP */}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Equipment;
